<template>
  <div :class="['sidebar', { 'is-scroll': !sidebar.collapse }, { 'showPcMenu': !sidebar.collapse }]">
      <SideMenuList :menuType="1"/>
  </div>
</template>

<script setup>
  import SideMenuList from "./sideMenuList.vue";
	import { computed } from "vue";
	import { useSidebarStore } from "../stores/sidebar";
	import { useRoute } from "vue-router";
	import menus from "../assets/js/menu";
  

	const route = useRoute();
	const onRoutes = computed(() => {
		return route.path;
	});

	const sidebar = useSidebarStore();
</script>

<style lang="scss" scoped>
	.sidebar {
		display: block;
		position: fixed;
		z-index: 10;
		left: 0;
		top: 70px;
		bottom: 0;
    border-radius: 0 0 50px 0; 
    &.is-scroll{
	    overflow-y: scroll;
      scrollbar-width: none; /* Firefox 支持 */
      -ms-overflow-style: none;  /* IE/Edge 支持 */
    // transition: all 2s;

      .el-menu{
        // margin-left: 10px;
        // width: 450px !important;
        // transition: all 2s;
      }
    }
    /* 隐藏滚动条轨道 (Chrome, Safari, Opera) */
    &.is-scroll::-webkit-scrollbar {
      display: none;
    }
		> p {
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			color: #bfcbd9;
		}
	}

	.sidebar::-webkit-scrollbar {
		width: 0;
	}

	// .sidebar-el-menu:not(.el-menu--collapse) {
	// 	width: 250px;
  //   transition: all 4s;
	// }

	// .sidebar > ul {
	// 	height: 100%;
	// }

	// .el-sub-menu .el-icon {
	// 	font-size: 1em;
	// }
  // .el-menu--collapse{
  //   width: 0px;
  //   transition: all 4s;
  //   // display: none;
  // }
  .showPcMenu{
    animation: my-animation 0.6s ease-in-out;
		width:225px;
  }
  #my-element {
	  animation: my-animation 1.2s;
		background-color:red;
		width:100px;
		height:100px;
	}
	
	@keyframes my-animation {
	    0% {
	        opacity: 0;
	        transform: translateX(-160%);
	    }
	    // 50% {
	    //     opacity: 0.5;
	    //     transform: translateX(-100%);
	    // }
	    100% {
	        opacity: 1;
	        transform: translateX(0%);
	    }
      // 0% {
	    //     opacity: 0;
	    //     transform: translateX(-300%);
	    // }
      // 30% {
	    //     opacity: 0.5;
	    //     transform: translateX(-200%);
	    // }
	    // 50% {
	    //     opacity: 0.7;
	    //     transform: translateX(-100%);
	    // }
      // 70% {
	    //     opacity: 0.3;
	    //     transform: translateX(0%);
	    // }
      // 90% {
	    //     opacity: 0.9;
	    //     transform: translateX(0%);
	    // }
	    // 100% {
	    //     opacity: 1;
	    //     transform: translateX(0%);
	    // }
	}
</style>
